import { render, staticRenderFns } from "./m_mainpage.vue?vue&type=template&id=b38d4260&scoped=true"
import script from "./m_mainpage.vue?vue&type=script&lang=js"
export * from "./m_mainpage.vue?vue&type=script&lang=js"
import style0 from "./m_mainpage.vue?vue&type=style&index=0&id=b38d4260&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38d4260",
  null
  
)

export default component.exports